var _path, _g, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_1308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 9,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9619 1.6669H19.0777V8.77758H11.9619V1.6669Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4525 8.77758C18.1383 8.77758 17.8683 8.54175 17.8325 8.22258C17.5167 5.40925 15.3317 3.22591 12.5175 2.91341C12.175 2.87508 11.9275 2.56675 11.9658 2.22341C12.0033 1.88091 12.3092 1.62841 12.6558 1.67175C16.0542 2.04925 18.6933 4.68508 19.0742 8.08258C19.1125 8.42591 18.8658 8.73508 18.5233 8.77341C18.5 8.77591 18.4758 8.77758 18.4525 8.77758Z",
    fill: "#313131"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5017 8.78657C15.2084 8.78657 14.9475 8.57991 14.8892 8.28157C14.6492 7.04824 13.6984 6.09741 12.4667 5.85824C12.1275 5.79241 11.9067 5.46491 11.9725 5.12574C12.0384 4.78657 12.3717 4.56491 12.705 4.63157C14.4392 4.96824 15.7784 6.30657 16.1159 8.04157C16.1817 8.38157 15.9609 8.70907 15.6225 8.77491C15.5817 8.78241 15.5417 8.78657 15.5017 8.78657Z",
    fill: "#313131"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_358_1308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 1.66658H18.7505V18.7503H1.66699V1.66658Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_358_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6329 4.21783C3.63456 4.21783 3.5929 4.26117 3.5404 4.31283C3.33873 4.50867 2.92123 4.91617 2.91706 5.76867C2.9104 6.96117 3.69456 9.17533 7.4704 12.9503C11.2279 16.707 13.4387 17.5003 14.6346 17.5003H14.6521C15.5046 17.4953 15.9112 17.0778 16.1071 16.877C16.1662 16.8162 16.2146 16.7703 16.2487 16.7428C17.0796 15.907 17.5046 15.2862 17.5004 14.887C17.4954 14.4803 16.9896 14.0003 16.2904 13.3345C16.0679 13.1237 15.8262 12.8928 15.5712 12.6378C14.9096 11.9787 14.5837 12.0912 13.8629 12.3445C12.8671 12.6937 11.5029 13.172 9.37706 11.0445C7.2504 8.91867 7.72706 7.5545 8.07456 6.55783C8.32623 5.83783 8.44123 5.51033 7.7804 4.84867C7.52206 4.59033 7.28956 4.34533 7.0754 4.12033C6.41373 3.42533 5.93623 2.92283 5.53206 2.917H5.5254C5.12623 2.917 4.50623 3.34367 3.62873 4.22117C3.63123 4.21867 3.63206 4.21783 3.6329 4.21783ZM14.6346 18.7503C12.5579 18.7503 9.8504 17.097 6.58706 13.8345C3.3104 10.5587 1.65456 7.84283 1.66706 5.762C1.67456 4.387 2.3954 3.68283 2.66623 3.41867C2.6804 3.40117 2.72873 3.35367 2.7454 3.337C3.94123 2.14117 4.7629 1.6495 5.5479 1.667C6.47873 1.6795 7.14206 2.377 7.98123 3.2595C8.18873 3.477 8.4129 3.7145 8.66373 3.9645C9.87956 5.18117 9.53373 6.17367 9.25456 6.97033C8.95123 7.8395 8.68873 8.5895 10.2604 10.1612C11.8321 11.7328 12.5812 11.4703 13.4496 11.1645C14.2471 10.8862 15.2371 10.5378 16.4554 11.7545C16.7029 12.002 16.9362 12.2237 17.1529 12.4295C18.0387 13.2728 18.7387 13.9387 18.7504 14.872C18.7596 15.667 18.2762 16.4787 17.0829 17.672L16.5546 17.3137L17.0021 17.7495C16.7379 18.0203 16.0354 18.742 14.6596 18.7503H14.6346Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/phone-number-icon.5d11892cdad35764cf54476740efa965.svg";
export { ForwardRef as ReactComponent };